var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-style-loader!css-loader?sourceMap!../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-329a5794\",\"scoped\":false,\"hasInlineConfig\":true}!stylus-loader!../node_modules/vue-loader/lib/selector?type=styles&index=0!./mavon-editor.vue")
  require("!!vue-style-loader!css-loader?sourceMap!../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-329a5794\",\"scoped\":true,\"hasInlineConfig\":true}!../node_modules/vue-loader/lib/selector?type=styles&index=1!./mavon-editor.vue")
}
var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./mavon-editor.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-329a5794\",\"hasScoped\":true}!../node_modules/vue-loader/lib/selector?type=template&index=0!./mavon-editor.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-329a5794",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/vercel/path0/src/mavon-editor.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] mavon-editor.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-329a5794", Component.options)
  } else {
    hotAPI.reload("data-v-329a5794", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/mavon-editor.vue
// module id = 212
// module chunks = 0